<template>
  <div class="container-fluid mt--6">
    <div class="row">
      <div class="col">
        <div class="card border-0">
          <div id="map-custom" class="map-canvas" style="height: 600px"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API_KEY } from './API_KEY'
import GoogleMapsLoader from 'google-maps'

GoogleMapsLoader.KEY = API_KEY

export default {
  methods: {
    initMap(google) {
      let map,
        lat = 33.7568239,
        lng = -84.3886777,
        color = '#68d391'
      map = document.getElementById('map-custom')

      let myLatlng = new google.maps.LatLng(lat, lng)
      let mapOptions = {
        zoom: 14,
        scrollwheel: false,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [
          {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#444444' }]
          },
          {
            featureType: 'landscape',
            elementType: 'all',
            stylers: [{ color: '#f2f2f2' }]
          },
          {
            featureType: 'poi',
            elementType: 'all',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'road',
            elementType: 'all',
            stylers: [{ saturation: -100 }, { lightness: 45 }]
          },
          {
            featureType: 'road.highway',
            elementType: 'all',
            stylers: [{ visibility: 'simplified' }]
          },
          {
            featureType: 'road.arterial',
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'transit',
            elementType: 'all',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'water',
            elementType: 'all',
            stylers: [{ color: color }, { visibility: 'on' }]
          }
        ]
      }

      map = new google.maps.Map(map, mapOptions)

      let marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
        animation: google.maps.Animation.DROP,
        title: 'Hello World!'
      })

      let contentString =
        '<div class="info-window-content"><h2>VIVA Finance, Inc</h2>' +
        '<p>100 Peachtree St NE STE 320, Atlanta, GA 30303</p></div>'

      let infowindow = new google.maps.InfoWindow({
        content: contentString
      })

      google.maps.event.addListener(marker, 'click', function () {
        infowindow.open(map, marker)
      })
    },
    retry(timeout) {
      setTimeout(
        () => (window.google ? this.initMap(window.google) : this.retry(timeout * 2)),
        timeout
      )
    }
  },
  mounted() {
    if (window.google) {
      this.initMap(window.google)
    } else {
      this.retry(100)
    }
  }
}
</script>
